export default "__VITE_ASSET__CAW8Bc8W__"